import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {IDjPsychoGameData, IWinClusterData} from "./server/IDjPsychoData";
import {DjPsychoSound} from "./sound/DjPsychoSound";
import {DjPsycho} from "./DjPsycho";
import {DjPsychoGameMode} from "./server/DjPsychoGameMode";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {SimpleReelModel} from "../core/reel/simplereel/SimpleReelModel";
import {TimelineLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class DjPsychoPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "DjPsycho",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "introBg"},
            mainGame: {
                header: () => DjPsycho.apiPlugin.translations.translate("xBET"),
                options: [
                    {name: "NORMAL", id: 0, image: "off.png"},
                    {name: "BOOSTED_BET", id: 1, image: "BOOSTED_BET.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            getParsedData: (response: IDjPsychoGameData, bet: number, prevResponse: IDjPsychoGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeBank,
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            DjPsycho.soundPlayer.playSound(DjPsychoSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            DjPsycho.soundPlayer.playSound(DjPsychoSound.AS_WIN_BIG);
        }
    }

    public onPlayBonusInGame(data: IDjPsychoGameData): void {
        DjPsycho.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        DjPsycho.model.onGame(<IDjPsychoGameData>data);
        for (let reelIdx: number = 0; reelIdx < DjPsycho.reelView.reelModels.length; reelIdx++) {
            const reel: SimpleReelModel = DjPsycho.reelView.reelModels[reelIdx];
            reel.clearSymbols(reel.symbols);
            for (let symIdx: number = 0; symIdx < data.evaluatedArea[reelIdx].length; symIdx++) {
                reel.init(data.evaluatedArea[reelIdx]);
            }
        }
        DjPsycho.model.gameData.evaluatedArea2.forEach((reel: string[], reelId: number) => {
            reel.forEach((val: string, symId: number) => {
                if (val && val !== "X") {
                    if (val === "W") {
                        DjPsycho.reelView.getVisibleSymbolAt(reelId, symId).updateTexture(val);
                    } else {
                        DjPsycho.reelView.getVisibleSymbolAt(reelId, symId).doSymbolDouble(val, reelId, symId, false);
                    }
                }
            });
        });
        const tl: TimelineLite = new TimelineLite(),
            mode: string = DjPsycho.model.gameData.mode,
            isUpgrade: boolean = (mode.indexOf(DjPsychoGameMode.NORMAL) === -1 && DjPsycho.model.gameData.nextMode === DjPsychoGameMode.FREESPIN_SUPER),
            activeColorsForFS: boolean[] = DjPsycho.model.gameData.activeColorsForFS;

        if (!(mode === DjPsychoGameMode.NORMAL && DjPsycho.model.gameData.wasFeatureBuy)) {

            activeColorsForFS.forEach((val: boolean, ctr: number) => {
                if (val) {
                    tl.add(DjPsycho.miniCollectors.activateCollectorIndicatorSpine(ctr, isUpgrade), 0);
                }
            });
            tl.addLabel("indicatorsAnimated");
            activeColorsForFS.forEach((val: boolean, ctr: number) => {
                if (val) {
                    tl.add(DjPsycho.miniCollectors.activateCollectorTextSpine(ctr, isUpgrade), "indicatorsAnimated");
                }
            });
        }
        DjPsycho.model.gameData.colorMultsAfterCollapse.forEach((val:number,idx:number) => {
            if(val>1){
                DjPsycho.miniCollectors.setColorMultiplier(idx,val)
            }
        });
        if(data.mode==="NORMAL"){
            DjPsycho.miniCollectors.activateTexts();
        }
        tl.add(() => {
            DjPsycho.introView.showIntro(() => DjPsycho.gameFlowController.start());
        });
        tl.progress(1);
    }

    private isBigWin(response: IDjPsychoGameData): boolean {
        let win = (response.mode === DjPsychoGameMode.NORMAL || response.mode === DjPsychoGameMode.NORMAL_AVALANCHE) ? response.accumulatedRoundWin : response.totalSpinWinnings;

        if (response.wasFeatureBuy) {
            const betPrice = DjPsycho.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getSpinWin(response: IDjPsychoGameData, bet: number, prevData: IDjPsychoGameData): number {
        return response.totalSpinRoundWinnings;
    }

    private isFreeSpinTriggered(response: IDjPsychoGameData): boolean {
        return response.freespinTriggeredThisSpin;
    }

    private getFeatureName(response: IDjPsychoGameData): string {
        if (response.nextMode == DjPsychoGameMode.FREESPIN || response.nextMode == DjPsychoGameMode.FREESPIN_AVALANCHE || response.mode == DjPsychoGameMode.FREESPIN || response.mode == DjPsychoGameMode.FREESPIN_AVALANCHE) {
            return "GEES! SPINZ";
        }

        if (response.nextMode == DjPsychoGameMode.FREESPIN_SUPER || response.nextMode == DjPsychoGameMode.FREESPIN_SUPER_AVALANCHE || response.mode == DjPsychoGameMode.FREESPIN_SUPER || response.mode == DjPsychoGameMode.FREESPIN_SUPER_AVALANCHE) {
            return "PSYCHO SPINZ";
        }

        return "";
    }

    private isRoundComplete(response: IDjPsychoGameData): boolean {
        return ([DjPsychoGameMode.FREESPIN, DjPsychoGameMode.FREESPIN_SUPER, DjPsychoGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IDjPsychoGameData): boolean {
        return ((response.nextMode === DjPsychoGameMode.NORMAL) && (response.mode === DjPsychoGameMode.FREESPIN || response.mode === DjPsychoGameMode.FREESPIN_SUPER));
    }


}